import React, { useState, useEffect, useRef } from 'react';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { Form, Button, Card, Modal } from 'react-bootstrap';
import { blackListSchema } from './schema';
import { Input, MaskInput } from '../Forms';
import FormikFillFields from '../Forms/FormikFillFields';
import { deleteBlackListRequest } from '../../security/reports/ReportSpecialList/actions';

type Props = {
  show: boolean;
  modalData: any;
  closeHandler: () => void;
  setModalData: (data: any) => void;
};

const EditBlackListModal: React.FC<Props> = ({ show, modalData, closeHandler, setModalData }) => {
  const dispatch = useDispatch();
  const [isReasonMode, setReasonMode] = useState<boolean>(false);
  const [btnDropdown, setBtnDropdown] = useState('driver');

  const [errText, setErrText] = useState<string>('');
  const formRef = useRef();

  useEffect(() => {
    if (!show) {
      setReasonMode(false);
    }
  }, [show]);

  useEffect(() => {
    if (modalData?.role === 0) {
      setBtnDropdown('driver');
    }
    if (modalData?.role === 1) {
      setBtnDropdown('forwarder');
    }
    if (modalData?.role === 2) {
      setBtnDropdown('vehicle');
    }
    if (modalData?.role === 3) {
      setBtnDropdown('trailer');
    }
  }, [modalData]);

  const openReasonHandler = () => {
    setReasonMode(true);
  };

  const changeHandler = (e: any) => {
    const value = e?.target?.value;

    if (!value?.length) {
      setErrText("Поле обов'язкове");
    } else {
      setErrText('');
    }
  };

  const onAddBL = (values: any) => {
    dispatch(deleteBlackListRequest(values.id));
    closeHandler();
  };

  if (!show) return null;

  return (
    <Modal backdrop="static" keyboard={false} centered show={show} onHide={closeHandler}>
      <Formik
        initialValues={modalData}
        // @ts-ignore
        innerRef={formRef}
        onSubmit={(values) => onAddBL(values)}
        validationSchema={() => blackListSchema(btnDropdown)}
        enableReinitialize
      >
        {({ handleSubmit, isValid }) => (
          <form onSubmit={handleSubmit}>
            <FormikFillFields />
            <Card>
              <Card.Header className="font-weight-bold">Чорний список</Card.Header>
              {!isReasonMode ? (
                <Card.Body>
                  {/* <DropdownButton */}
                  {/*  className="w-50 mb-2" */}
                  {/*  menuAlign="left" */}
                  {/*  variant="outline-secondary" */}
                  {/*  // @ts-ignore */}
                  {/*  title={DROPDOWN_BTN[btnDropdown]} */}
                  {/*  aria-readonly */}
                  {/* > */}
                  {/*  {Object.keys(DROPDOWN_BTN).map((o) => ( */}
                  {/*    // @ts-ignore */}
                  {/*    <Dropdown.Item key={`dropdown_${o}`} as="button" onClick={() => setBtnDropdown(o)}> */}
                  {/*      { */}
                  {/*        // @ts-ignore */}
                  {/*        DROPDOWN_BTN[o] */}
                  {/*      } */}
                  {/*    </Dropdown.Item> */}
                  {/*  ))} */}
                  {/* </DropdownButton> */}
                  {btnDropdown === 'driver' ? (
                    <div>
                      <MaskInput
                        name="number"
                        label="Телефон"
                        placeholder="38 (0XX) XXX-XX-XX"
                        onChange={changeHandler}
                        value={modalData?.number}
                        isOptRequired
                      />
                      <Input name="description" label="ПІБ" onChange={changeHandler} maxLength={40} isOptRequired />
                    </div>
                  ) : null}
                  {btnDropdown === 'forwarder' ? (
                    <div>
                      <MaskInput
                        name="number"
                        label="Телефон"
                        placeholder="38 (0XX) XXX-XX-XX"
                        onChange={changeHandler}
                        value={modalData?.number}
                        isOptRequired
                      />
                      <Input name="description" label="ПІБ" onChange={changeHandler} maxLength={40} isOptRequired />
                    </div>
                  ) : null}

                  {btnDropdown === 'trailer' || btnDropdown === 'vehicle' ? (
                    <div>
                      <Input
                        name="number"
                        label="Держномер"
                        onChange={changeHandler} // @ts-ignore
                        maxLength={11}
                        minLength={4}
                        value={modalData?.number}
                        isOptRequired
                      />
                      <Input name="description" label="Марка" onChange={changeHandler} maxLength={40} isOptRequired />
                    </div>
                  ) : null}

                  <Form.Group>
                    <Form.Control.Feedback type="invalid">{errText}</Form.Control.Feedback>
                  </Form.Group>

                  <div className="d-flex justify-content-around">
                    <Button
                      className="mt-3 px-5"
                      onClick={() => {
                        setModalData({});
                        closeHandler();
                      }}
                      variant="outline-secondary"
                    >
                      Вийти
                    </Button>

                    <Button
                      className="mt-3 px-5"
                      onClick={openReasonHandler}
                      variant="outline-danger"
                      disabled={!isValid}
                    >
                      Видалити
                    </Button>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>
                  <h6 className="text-center">Видалити з чорного списку?</h6>
                  <div className="d-flex justify-content-around">
                    <Button className="mr-4 px-5" onClick={closeHandler} variant="outline-secondary">
                      Ні
                    </Button>
                    <Button className="px-5" type="submit" variant="outline-danger">
                      Так
                    </Button>
                  </div>
                </Card.Body>
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditBlackListModal;
